import { React, useState, useRef, useEffect } from 'react'
import './Login-staff.css'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import logo from '../Images/logo.png'
import UseCustomFormik from './formik_staff';
import FormComponent from '../components/FormComponents/FormComponent';
import OtpInput from 'react-otp-input';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import BackEndUrl from '../backURL';
import axios from 'axios';
import loading from "../Images/three-dots.svg"
import { Avatar } from '@nextui-org/react';




const backend = BackEndUrl.domain
const desiredTimezone = 'Asia/Colombo';
function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
}
const StaffPanelLogin = () => {

    const [data, setData] = useState(null);
    const toast = useRef(null);
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState(''); //otp enterd be the user
    const [genOpt, setGenOpt] = useState(null); //generated otp
    const [countdown, Setcountdown] = useState(0);
    const [verified, setVerified] = useState(false)//to check whether req to generate the token is send
    const [otpLoaded, setotpLoaded] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false)
    const [visible, setVisible] = useState(false);
    const countDownInterval = useRef(null);
    function handleKeyPress(event) {
       
        if (event.key === 'Enter') {
            OnclickSendOTP()
        }
      }
     async function CheckForOTP() {

        try {

            const response = await axios.post(backend + "/staff-otp-check", {

                nic: sessionStorage.getItem("StaffTempNIC") || "",
                mobile: sessionStorage.getItem("StaffTempMobile") || "",


            }, {
                headers: {
                    Authorization: sessionStorage.getItem('staff-token'),
                }
            });
            return response.data



        }
        catch (err) {
            console.log(err)

        }

    }
    useEffect(() => {
        async function GetData() {
            try {
                const response = await axios.get(backend + "/staff-data");                             
                setData(response.data);             

            } catch (error) {
                console.log(error);
            }
        }

        if (!data) {
            GetData();
        }
        async function CheckForAssignedOTP() {
            const existingValidOtp = await CheckForOTP();
            if (existingValidOtp.length != 0) {
                setGenOpt(existingValidOtp[0].otp)
                const otpSentTime = new Date(existingValidOtp[0].opt_sent_time);
                const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));


                Setcountdown(timeDifferenceInMinutes)
                setIsLoaded(true)
                setotpLoaded(true)
                countingDown()
            } else {
                setIsLoaded(true)
            }

        }
        if (!genOpt && !countdown) {
            CheckForAssignedOTP()

        }

    }, [data]);


    async function TokenCreation() {
        try {

            const response = await axios.post(backend + "/auth-token", {
                nic: sessionStorage.getItem('nic'),
                mobile: sessionStorage.getItem('mobile'),
            }
            )
            

            sessionStorage.setItem("staff-token", response.data.token)
            sessionStorage.setItem('nic', formik.values.NIC)
            sessionStorage.setItem('mobile', formik.values.Mobile)
            sessionStorage.setItem('staff-logged', true)
            const indexUser= data?.findIndex(item => item.nic ===formik.values.NIC && item.mobile === formik.values.Mobile);         
                       
            //sessionStorage.setItem("full_name", data[indexUser].full_name)  

           if(indexUser != -1){
            sessionStorage.setItem("full_name", data[indexUser].full_name)            
            
           } 
            window.location.href = '/customer-portal/staff-panel'
        }
        catch (err) {
            console.log(err);
        }
    }
    //After the OTP is submited by the user 
    
    function OtpSubmition(value) {
        if (value == genOpt) {
            setVerified(true);

            TokenCreation();

        } else {
       
        
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid OTP',
              description:"Please Check the OTP"
              ,
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                    <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                    <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                </div>
              ),
            });
    
        }
    }
    async function sendOtp() {

        try {

            const response = await axios.post(backend + "/staff-otp", {

                nic: formik.values.NIC,
                mobile: formik.values.Mobile,

            }, {
                headers: {
                    Authorization: sessionStorage.getItem('staff-token'),
                }
            });
            if(response.data){
                toast.current.clear();
                toast.current.show({
                  severity: 'success',
                  summary: 'OTP Send Sucessfully',
                  description:"Check your mobile "
                  ,
                  life: 3000,
                  sticky: false,
                  content: (props) => (
                    <div className="p-3" style={{ flex: '1' }}>
                        <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                        <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                    </div>
                  ),
                });
            }
            return (response.data)



        }
        catch (err) {
            console.log(err)

        }
    }
    //Cooling down the  OTP requests
    function countingDown() {

        if (countDownInterval.current) {
            clearInterval(countDownInterval.current);
        }
        countDownInterval.current = setInterval(() => {
            Setcountdown(prevCountdown => {
                if (prevCountdown > 0) {
                    return prevCountdown - 1;
                } else {
                    clearInterval(countDownInterval.current);
                    setGenOpt(null)
                    return 0;
                }
            });
        }, 1000);

    }

    async function OnclickSendOTP() {

        if (countdown == 0) {
            formik.validateForm().then(async (errors) => {
                sessionStorage.setItem("StaffTempNIC", formik.values.NIC)
                sessionStorage.setItem("StaffTempMobile", formik.values.Mobile)
                setOtp(null)
                if (Object.keys(errors).length === 0) {
                    const existingValidOtp = await CheckForOTP();

                    if (existingValidOtp.length == 0) {
                        const newOtp = await sendOtp()
                        setGenOpt(newOtp.otp)
                        setotpLoaded(true)
                        const otpSentTime = new Date(newOtp.otp_sent_time);
                        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                        const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));
                        setStep(2)

                        Setcountdown(timeDifferenceInMinutes)
                        countingDown()
                    }
                    else {

                        setGenOpt(existingValidOtp[0].otp)
                        setotpLoaded(true)
                        const otpSentTime = new Date(existingValidOtp[0].opt_sent_time);
                        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                        const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));
                        setStep(2)
                        Setcountdown(timeDifferenceInMinutes)
                        countingDown()
                    }
                }
            });
        }

        else {
            setStep(2)
            setOtp(null)
        }
    }


    const optStyle = {
        width: "4vw",
        height: "7vh",
        marginLeft: "0.5vw",
        marginRight: "0.5vw",
        borderRadius: "0.3em",
        border: "1px solid #f7931b",
        transition: "border-color 0.3s"

    }
    // sending the data for validation
    const formik = UseCustomFormik(step, data)

    //Auto submition of the OTP code
    function onchangeOtp(value) {
        if (value.length === 6) {
            OtpSubmition(value);
        }

        setOtp(value);

    }

    
    if (!sessionStorage.getItem('staff-logged')) {
        if (data) {
            return (


                <Row className='d-flex justify-content-center login-con align-items-center' >
                   
                    <Col xs={5} >
 
     <Toast ref={toast}  position="top-center"  />
                        {step == 1 &&

                            // login page
                            <motion.div
                            onKeyDown={handleKeyPress}
                                initial={{
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "40em",
                                    borderBottomLeftRadius: "40em",
                                    borderBottomRightRadius: "0em",
                                    scale: 0.5,
                                    opacity: 0,



                                }}
                                animate={{
                                    opacity: 1,
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "9em",
                                    borderBottomLeftRadius: "9em",
                                    borderBottomRightRadius: "0em",
                                    scale: 1

                                }}



                                className='login-inner'>
                                <motion.div
                                    initial={{

                                        opacity: 0

                                    }}
                                    animate={{
                                        opacity: 1

                                    }}
                                    exit={{
                                        opacity: 0

                                    }}
                                    transition={{ duration: 0.3 }}

                                >
                                    <Row>
                                        <Col xs={2} className='logo-con mx-3 mt-2'>
                                            <img src={logo} className='logo' />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col xs={12} className='d-flex justify-content-center'>
                                            <h4 className='title'><span style={{ color: "#00aaef" }}>Staff</span> <span style={{ color: "#f7941d" }}>Login</span> </h4>
                                        </Col>
                                    </Row>
                                    <Row className='d-flex justify-content-center align-items-center form-container'>
                                        <Col xs={6}>
                                            <div className='mt-4'>
                                                <FormComponent
                                                    type="input-alphanum"
                                                    label="NIC Number"
                                                    value={formik.values.NIC}
                                                    errors={formik.errors.NIC}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        formik.setValues({
                                                            ...formik.values,
                                                            NIC: e.target.value.toUpperCase(),
                                                        });
                                                    }}
                                                    name={"NIC"}

                                                    style={
                                                        {
                                                            height: "6vh",


                                                        }

                                                    }

                                                />
                                                <FormComponent
                                                    type="input-number"
                                                    label="Mobile Number"
                                                    value={formik.values.Mobile}
                                                    onChange={formik.handleChange}
                                                    name="Mobile"
                                                    errors={formik.errors.Mobile}

                                                    style={
                                                        { height: "6vh" }
                                                    }

                                                />

                                            </div>

                                        </Col>

                                    </Row>

                                    <Row className='d-flex justify-content-end mt-5'>
                                        
                                        <Col xs={3} className='justify-content-start d-flex'>


                                            <motion.button
                                                whileTap={{ scale: 0.9 }}
                                                className={`btn btn-warning login-btn  `}

                                                onClick={() => { OnclickSendOTP() }}
                                                style={{ height: "120%" }}
                                            >
                                                <span className='d-flex flex-column' style={{ position: "relative" }}>

                                                    <span> Login</span>


                                                </span>
                                            </motion.button>
                                        </Col>
                                    </Row>


                                </motion.div>


                            </motion.div>}





                        {step == 2 &&
                            // otp page
                            <motion.div
                                initial={{
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "40em",
                                    borderBottomLeftRadius: "40em",
                                    borderBottomRightRadius: "0em",
                                    scale: 0.5,
                                    opacity: 0,




                                }}
                                animate={{
                                    opacity: 1,
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "9em",
                                    borderBottomLeftRadius: "9em",
                                    borderBottomRightRadius: "0em",
                                    scale: 1,

                                }}
                                exit={
                                    {
                                        opacity: 0


                                    }
                                }
                                transition={{ duration: 0.3 }}


                                className='login-inner'>
                                <motion.div
                                    initial={{

                                        opacity: 0

                                    }}
                                    animate={{
                                        opacity: 1

                                    }}
                                    exit={{
                                        opacity: 0

                                    }}
                                    transition={{ duration: 0.2 }}

                                >
                                    <Row>
                                        <Col xs={2} className='logo-con mx-3 mt-2'>
                                            <img src={logo} className='logo' />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col xs={12} className='d-flex justify-content-center '>

                                            <h3 className='opt-title'>Enter Verification Code</h3>
                                        </Col>
                                    </Row>
                                    <Row className='opt-con align-items-center justify-content-center' style={{ width: "100%" }}>

                                        <Col xs={12} className='d-flex justify-content-center align-items-center flex-column'>

                                            <Row className='d-flex justify-content-start'>
                                                <Col xs={12} style={{ textAlign: "" }} className='my-3'>
                                                    {countdown > 0 ?
                                                        <p>Time Remaining {formatTime(countdown)}</p> :

                                                        <Message severity="error" style={{ textAlign: "center" }} text=" OTP expired" />

                                                    }
                                                </Col>

                                            </Row>
                                            <OtpInput
                                                value={otp}
                                                onChange={(value) => onchangeOtp(value)}
                                                numInputs={6}
                                                renderSeparator={<span style={{ color: "#00adf1" }}>-</span>}
                                                renderInput={(props) => <input class={"opt-input"} {...props} />}
                                                inputStyle={optStyle}


                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} className='d-flex justify-content-center'>
                                            <motion.button whileTap={{ scale: 0.9 }} className='btn  login-btn-blue mx-2' onClick={() => setStep(1)}>Back</motion.button>
                                            <motion.button
                                                whileTap={{ scale: 0.9 }}
                                                className={`btn login-btn mx-2 ${countdown > 0 ? 'disabled' : ''}`}
                                                disabled={countdown > 0 ? true : false}
                                                onClick={() => { OnclickSendOTP() }}
                                            >
                                                <span className='d-flex flex-column' style={{ position: "relative" }}>
                                                    <span>Re Send</span>
                                                    <span style={{ fontSize: "10px", position: "absolute", top: "70%", left: "40%" }}>{countdown > 0 && formatTime(countdown)}</span>

                                                </span>
                                            </motion.button>
                                            <motion.button whileTap={{ scale: 0.9 }} className='btn  login-btn-blue mx-2' onClick={()=>{OtpSubmition(otp)}}>Next</motion.button>
                                        </Col>
                                    </Row>

                                    {verified &&
                                        <Row className='d-flex justify-content-center '>
                                            <img src={loading} className='m-5' style={{ width: "10%" }} />
                                        </Row>}
                                </motion.div>


                            </motion.div>}



                    </Col>

                </Row>



            )
        }
        else {
            return (
                <LoadingScreen />
            )
        }
    }
    else{
        window.location.href = "/customer-portal/staff-panel"
    }
    
}

export default StaffPanelLogin
